<template>
  <div
    class="letter"
    :class="{ 'guessed': guessed, 'flipped': flipped, 'missed': missed }"
  >{{ displayValue }}</div>
</template>

<script>
export default {
  name: "SolutionTile",
  props: {
    letter: String,
    gameStatus: String,
    correctGuesses: Array,
    initialDisplayValue: String
  },
  data: function() {
    return {
      displayValue: this.initialDisplayValue
    };
  },
  computed: {
    guessed: function() {
      return this.correctGuesses.includes(this.letter);
    },
    gameLost: function() {
      return this.gameStatus === "lost";
    },
    flipped: function() {
      return this.guessed || this.gameLost;
    },
    missed: function() {
      return this.gameLost && !this.guessed;
    }
  },
  watch: {
    flipped(newValue) {
      if (newValue) {
        setTimeout(this.revealLetter, 550);
      }
    },
    gameStatus(newStatus) {
      if (newStatus === "playing") {
        this.displayValue = this.initialDisplayValue;
      }
    }
  },
  methods: {
    revealLetter: function() {
      this.displayValue = this.letter;
    }
  }
};
</script>

<style scoped>
/* ----------------------------------------------
 * Generated by Animista on 2019-10-31 16:10:23
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

.flipped {
  -webkit-animation: flip-horizontal-bottom 0.8s
    cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
  animation: flip-horizontal-bottom 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955)
    both;
}

/**
 * ----------------------------------------
 * animation flip-horizontal-bottom
 * ----------------------------------------
 */

@-webkit-keyframes flip-horizontal-bottom {
  0% {
    -webkit-transform: rotateX(-180deg);
    transform: rotateX(-180deg);
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
}
@keyframes flip-horizontal-bottom {
  0% {
    -webkit-transform: rotateX(-180deg);
    transform: rotateX(-180deg);
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
}
</style>
